export default "__VITE_ASSET__Bv3KKphh__"